import { Component, inject, Injector, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { RowClickedEvent, RowDoubleClickedEvent } from 'ag-grid-community';
import { SafePipe } from 'safe-pipe';
import { jkGlb, MaterialModule } from 'jk-service';
import { JobMailOption, ReportService } from 'jk-service';
import { MatTabChangeEvent } from '@angular/material/tabs';
//import { DispatcherParamComponent } from '../dispatcher-param/dispatcher-param.component';
import { JkgridwinComponent, jkQueryComponent } from 'jk-advcom';
import { idNameItem, JkJobKind } from 'jk-service';
import { downloadURI, jkAlert, jkLib, JkdownloadFileComponent } from 'jk-service';
import { JkbtneditComponent } from 'jk-advcom';
import { JackBaseComponentModule } from 'jk-service';

/**
 * 派班查詢
 *
 * @export
 * @class Syspq80Component
 * @extends {jkQueryComponent}
 * @implements {OnInit}
 */
@Component({
  selector: 'app-syspq80',
  standalone: true,
  imports: [JackBaseComponentModule, MaterialModule, SafePipe,
    JkgridwinComponent,
    JkbtneditComponent,
  ],
  templateUrl: './syspq80.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './syspq80.component.css'
})
export class Syspq80Component extends jkQueryComponent implements OnInit {
  override _programId = 'syspq80'; // ###
  @ViewChild('jkdownload') downloadFile!: JkdownloadFileComponent;
  pageOpt: JobMailOption = new JobMailOption(this.programId + '_page');//###
  //filterOpt: FilterOption = new FilterOption(this.programId);//###
  orderList: idNameItem[] = [];
  urlPath: string = '';
  date = '';
  //reportUrl: string = '';
  dbname: string = '';
  fileName: string = '';
  ka004: string = '';
  ka008: string = '';
  ka014: string = '';
  kind: number = 0;
  public reportSrv: ReportService = inject(ReportService);
  constructor() {
    super();
    this.onOpenReport.bind(this);
    this.onOpenReport.bind(this);
    this.onDownloadReport.bind(this);
    this.gridInitOpt = { pageKind: this.pageKind, programId: this.programId, sortField: 'KA001', sort: 'desc', defaultSort: null };

    this.setFormOpt2();//###
    this.logMessage = '無錯誤訊息';
    //this.reportUrl = environment.reportUrl;
    this.dbname = this.login.dbname;

  }
  setReportPath(file: string) {
    if (file) {
      this.fileName = file;
      this.urlPath = this.reportSrv.setReportPath(jkGlb.env.reportUrl, file);
    } else {
      this.urlPath = '';
      this.fileName = '';
    }
  }

  override ngOnInit() {
    super.ngOnInit();

  }

  override async ngAfterViewInit() {
    super.ngAfterViewInit();
    if (this.downloadFile) {
      this.downloadFile.init('', '', 'application/pdf');
    }

    this.checkAllInit(this);// 這行要放在 ngAfterViewInit 最後  ###
    //this.doQuery();

  }
  doSelectRow(e: RowClickedEvent<any, any>) {
    this.urlPath = '';
    this.fileName = '';
    if (this.masterGrid && this.masterGrid.focusedRowIndex < 0) {
      return;
    }
    let item = this.masterGrid.selectedItem; //this.masterGrid.itemList[this.masterGrid.focusedRowIndex];
    this.ka008 = item['KA008'];
    this.ka014 = item['KA014'];
    if (this.ka008 === JkJobKind.Report) {
      if (item['成功筆數'] === 0) {
        return;
      };
      // 設定 urlPath iFrame 的路徑, 並顯示 iFrame
      this.setReportPath(item["FILENAME"]);
    }
    return;
  }
  override agRowClicked($event: RowClickedEvent<any, any>) { // RowClickedEvent<any, any>
    if (!$event.rowIndex) // 過濾掉 不知哪來的事件
      return;
    super.agRowClicked($event);
    this.doSelectRow($event);

  };
  override async beforeQuery(): Promise<boolean> {
    await super.beforeQuery();

    this.type = 'S';
    this.winItem = 'S01';
    this.mainTable = 'SYSKA';
    this.where = " AND KA003= " + jkLib.quotedStr(this.dbname)
      + " AND KA015=" + jkLib.quotedStr(this.uid);

    this.order = " ORDER BY KA001 DESC, KA002 DESC ";
    return true;
  }
  override onAfterQuery(item: any, ret: any) {
    super.onAfterQuery(item, ret);
    if (item)
      this.setReportPath(item["FILENAME"]);

  }
  async onDownloadReport(): Promise<boolean> {

    if (this.masterGrid && this.masterGrid.focusedRowIndex < 0) {
      jkAlert("請選擇一筆資料", "打開報表");
      return false;
    }
    if (this.masterGrid.itemList.length === 0) {
      jkAlert("無資料", "打開報表");
      return false;
    }
    let uri: string;
    let ndx = this.masterGrid.focusedRowIndex;
    if (!ndx) return false;
    let item = this.masterGrid.itemList[ndx];
    if (item['成功筆數'] === 0) {
      jkAlert("無符合資料.未產生報表", "打開報表");
      return false;
    };
    // 設定 urlPath iFrame 的路徑, 並顯示 iFrame
    //this.urlPath = this.reportUrl + "/" + Login.dbname + "/" + item["FILENAME"]; //myTable.rowData["FILENAME"];
    this.setReportPath(item["FILENAME"]);
    downloadURI(this.urlPath);
    return true;
  }
  async onOpenReport(): Promise<boolean> {

    if (this.masterGrid && this.masterGrid.focusedRowIndex < 0) { // && this.masterGrid.focusedValue
      jkAlert("請選擇一筆資料", "打開報表");
      return false;
    }
    if (this.masterGrid.itemList.length === 0) {
      jkAlert("無資料", "打開報表");
      return false;
    }
    let uri: string;
    const ndx = this.masterGrid.focusedRowIndex;
    if (!ndx) return false;
    let item = this.masterGrid.itemList[ndx];
    if (item['成功筆數'] === 0) {
      jkAlert("無符合資料.未產生報表", "打開報表");
      return false;
    };
    // 設定 urlPath iFrame 的路徑, 並顯示 iFrame
    this.setReportPath(item["FILENAME"]);
    this.masterTabGroupIndex = 2;
    return true;
  }

  override agRowDoubleClicked($event: RowDoubleClickedEvent<any, any>) {
    super.agRowDoubleClicked($event);
    this.onOpenReport();
  }
  doMail() {
    /* {"from":"nobody1@jack168.com","to":"jackie@jack168.com","subject":"test","text":"http://jack168.com/report/JACKIE/20240504-1449-MTRKR03.PDF  "}*/
    if (!this.pageOpt.mailFrom || !this.pageOpt.mailTo) {
      jkAlert('請設定寄件人與收件人');
      return;
    }
    let body = {
      from: this.pageOpt.mailFrom,
      to: this.pageOpt.mailTo,
      subject: '報表:' + this.fileName,
      text: this.urlPath
    };
    this.orm.sendMail(body, this.ret).subscribe(
      (data: any) => {
        if (data.errorLog) {
          jkAlert(data.errorLog);
        } else {
          jkAlert('Mail sent');
        }
      }, (error: any) => {
        jkAlert('Mail sent error:' + error.message);
      }
    );
    //alert('Mail功能尚未完成');
  }
  doChangeNotYet() {
    throw new Error('Method not implemented.');
  }
  doDelete() {
    throw new Error('Method not implemented.');
  }
  doRunNow() {
    throw new Error('Method not implemented.');
  }
  onJobTabChange($event: MatTabChangeEvent) {
    this.kind = $event.index;
    this.doMyQuery();
  }
  doMyQuery() {
    if (!this.masterGrid) {
      return;
    }
    let where = '';
    let order = '';
    let datetime = this.nowDate() + this.nowTime4();
    if (this.kind === 0) { // 未執行工作
      //  /*WHERE*/ WHERE KA003=:USER AND KA006=0 AND KA001+KA002<=:TIME1`;
      where = ` AND KA003='${this.dbname}' AND KA001+KA002<='${datetime}' `;
      this.masterGrid.doQuery2('SYSPQ80', 'S01', 'S', where, order, []);

      this.masterTabGroupIndex = 1;
    };
    if (this.kind === 1) { // 已執行工作
      // WHERE KA006<>0
      where = ` AND KA003='${this.dbname}' `;
      this.masterGrid.doQuery2('SYSPQ80', 'S02', 'S', where, order, []);
      this.masterGrid.doQuery2('SYSPQ80', 'S02', 'S', where, order, []);

      this.masterTabGroupIndex = 1;
    };
    if (this.kind === 2) { // 預定執行工作
      where = ` AND KA003='${this.dbname}' AND KA001+KA002>'${datetime}'  `;
      this.masterGrid.doQuery2('SYSPQ80', 'S03', 'S', where, order, []);

      this.masterTabGroupIndex = 1;
    };
    if (this.kind === 3) { // 定時工作建立
      where = `  AND COMPANYID='${this.dbname}' `;
      order = `/*ORDER*/ ORDER BY SE109,SE110`;
      this.masterGrid.doQuery2('SYSPQ80', 'S04', 'S', where, order, []);

      this.masterTabGroupIndex = 1;
    };
    if (this.kind === 4) { // 報表
      where = `  AND KA003='${this.dbname}' `;
      order = `/*ORDER*/ ORDER BY KA001 DESC,KA002 DESC,KA003,KA004`;
      this.masterGrid.doQuery2('SYSPQ80', 'S05', 'S', where, order, []);

      this.masterTabGroupIndex = 1;
    };

  }

}
